// import React, { useEffect, useState } from "react";
// import { Link, useNavigate, useParams } from "react-router-dom";
// import { FaPlus, FaEye } from "react-icons/fa";
// import { Modal, Button, Form, Table, Pagination, Row, Col, Container, Spinner } from "react-bootstrap";
// import { FaEdit } from "react-icons/fa";
// import { RiDeleteBin3Fill } from "react-icons/ri";
// import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";
// import { BsThreeDots } from "react-icons/bs";

// const API_URL = process.env.REACT_APP_API_URL;

// function ExpensesByDate() {
//     const { date } = useParams();
//     const navigate = useNavigate();
//     const [expenses, setExpenses] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [dataLoading, setDataLoading] = useState(true);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [totalPages, setTotalPages] = useState(1);
//      const formatText = (text) => {
//         if (!text || typeof text !== "string") return "NA";
//         return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//     };

//     const getAuthToken = () => {
//         return localStorage.getItem("token");
//     };
//     const fetchExpenses = async (page = 1) => {
//         const token = getAuthToken();
//         if (!token) {
//             setLoading(false);
//             setDataLoading(false);
//             return;
//         }

//         setLoading(true);
//         try {
//             const response = await fetch(`${API_URL}/expence-datewaise-list?date=${date}&page=${page}&limit=10`, {
//                 method: "GET",
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                 },
//             });
//             if (!response.ok) {
//                 throw new Error("Failed to fetch expenses.");
//             }
//             const data = await response.json();
//             console.warn(data);
//             if (data.status) {
//                 setExpenses(data.data);
//                 setTotalPages(data.totalPages || 1);
//                 setCurrentPage(data.currentPage || page);
//             } else {
//                 alert("Error", data.message, "error");
//             }
//         } catch (error) {
//             console.error("Failed to fetch expenses:", error);

//         } finally {
//             setLoading(false);
//             setDataLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchExpenses(currentPage);
//     }, []);

//     const handlePageChange = (pageNumber) => {
//         if (pageNumber > 0 && pageNumber <= totalPages) {
//             setCurrentPage(pageNumber);
//             fetchExpenses(pageNumber);
//         }
//     };



//     return (
//         <Container fluid>
//             <div className="card">
//                 <div className="card-header">
//                     <div className="d-flex justify-content-between align-items-center">
//                         <div className="titlepage">

//                             <h3 className="mb-0">Datewise CR / DR Ledger Report</h3>
//                         </div>
//                         <Link to="/expenses-date-wise" className="btn btn-primary">
//                             Back
//                         </Link>

//                     </div>
//                 </div>
//                 <div className="card-body">
//                     <Row className="">
//                         <Col>
                           

//                             {dataLoading ? (
//                                 <div className="text-center p-5">
//                                     <Spinner animation="border" />
//                                     <p className="mt-2">Loading expenses...</p>
//                                 </div>
//                             ) : (
//                                 <>
//                                     <Table striped bordered hover responsive className="shadow-sm">
//                                         <thead>
//                                             <tr>
//                                                 <th>ID</th>
//                                                  <th>Category Name</th>
//                                                 <th>Category Type</th>
//                                                 <th>Payee Name</th>
//                                                 <th>Type</th>
//                                                 <th>Expense Date</th>
//                                                 <th>Pay Date</th>
//                                                 <th>Project Name</th>
//                                                 <th>Unit Number</th>
//                                                 <th>Descriptions</th>
//                                                 <th>CR Amount</th>
//                                                 <th>DR Amount</th>
//                                                 <th>Balance</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                            {expenses.length > 0 ? (
//                                                 expenses.map((expense, index) => (
//                                                     <tr key={expense.id}>
//                                                         <td>{index + 1}</td>
//                                                         <td>
//                                                             {(expense.category_name)}
//                                                         </td>
//                                                         <td>
//                                                             {expense.category_type || "NA"}
//                                                         </td>
//                                                         <td>
//                                                             {formatText(expense.payee)}
//                                                         </td>

//                                                         <td>
//                                                             <span style={{ color: "blue" }}>
//                                                                 {expense.type}
//                                                             </span>
//                                                         </td>
//                                                         <td>
//                                                             {(() => {
//                                                                 const d = new Date(expense.date);
//                                                                 const day = String(d.getDate()).padStart(2, "0");
//                                                                 const month = String(d.getMonth() + 1).padStart(2, "0");
//                                                                 const year = d.getFullYear();
//                                                                 return `${day}-${month}-${year}`;
//                                                             })()}
//                                                         </td>
//                                                         <td>
//                                                             {(() => {
//                                                                 const d = new Date(expense.created_at);
//                                                                 const day = String(d.getDate()).padStart(2, "0");
//                                                                 const month = String(d.getMonth() + 1).padStart(2, "0");
//                                                                 const year = d.getFullYear();
//                                                                 return `${day}-${month}-${year}`;
//                                                             })()}
//                                                         </td>
//                                                         <td>
//                                                             {expense.project_name || "NA"}
//                                                         </td>
//                                                         <td>
//                                                             {expense.plot_shop_villa_no || "NA"}
//                                                         </td>
//                                                         <td>
//                                                             <div className="table-cell-remark">
//                                                                 {expense.description ? (expense.description.charAt(0).toUpperCase() + expense.description.slice(1).toLowerCase()) : "NA"}
//                                                             </div>
//                                                         </td>
//                                                         <td>
//                                                             {/* CR Amount Column */}
//                                                             {expense.category_type === 'cr' ? (
//                                                                 <span style={{ color: "green", fontWeight: "bold" }}>
//                                                                     ₹ {expense.amount}
//                                                                 </span>
//                                                             ) : (
//                                                                 <span style={{ color: "#ccc" }}>₹ 0</span>
//                                                             )}
//                                                         </td>
//                                                         <td>
//                                                             {/* DR Amount Column */}
//                                                             {expense.category_type === 'dr' ? (
//                                                                 <span style={{ color: "red", fontWeight: "bold" }}>
//                                                                     ₹ {expense.amount}
//                                                                 </span>
//                                                             ) : (
//                                                                 <span style={{ color: "#ccc" }}>₹ 0</span>
//                                                             )}
//                                                         </td>
//                                                         <td>
//                                                             {/* Balance Column */}
//                                                             <span
//                                                                 style={{
//                                                                     color: expense.running_balance >= 0 ? "green" : "red",
//                                                                     fontWeight: "bold"
//                                                                 }}
//                                                             >
//                                                                 ₹ {expense.running_balance?.toLocaleString() || 0}
//                                                             </span>
//                                                         </td>
//                                                         {/* <td>
//                                                             {(() => {
//                                                                 const d = new Date(expense.date);
//                                                                 const day = String(d.getDate()).padStart(2, "0");
//                                                                 const month = String(d.getMonth() + 1).padStart(2, "0");
//                                                                 const year = d.getFullYear();
//                                                                 return `${day}-${month}-${year}`;
//                                                             })()}
//                                                         </td> */}
//                                                     </tr>
//                                                 ))
//                                             ) : (
//                                                 <tr>
//                                                     <td colSpan="8" className="text-center">No expenses found.</td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </Table>

//                                     <div className="d-flex justify-content-end">
//                                         <nav>
//                                             <ul className="pagination">
//                                                 <li className="page-item">
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => handlePageChange(currentPage - 1)}
//                                                         disabled={currentPage === 1}
//                                                         aria-label="Previous"
//                                                     >
//                                                         <HiOutlineChevronLeft />
//                                                     </button>
//                                                 </li>

//                                                 {[...Array(totalPages)].map((_, index) => (
//                                                     <li key={index + 1} className="page-item">
//                                                         <button
//                                                             className={`page-link ${index + 1 === currentPage ? "active" : ""}`}
//                                                             onClick={() => handlePageChange(index + 1)}
//                                                         >
//                                                             {index + 1}
//                                                         </button>
//                                                     </li>
//                                                 ))}

//                                                 <li className="page-item">
//                                                     <button
//                                                         className="page-link"
//                                                         onClick={() => handlePageChange(currentPage + 1)}
//                                                         disabled={currentPage === totalPages}
//                                                         aria-label="Next"
//                                                     >
//                                                         <HiChevronRight />
//                                                     </button>
//                                                 </li>
//                                             </ul>
//                                         </nav>
//                                     </div>
//                                 </>
//                             )}
//                         </Col>
//                     </Row>
//                 </div>
//             </div>

//         </Container>
//     );
// }

// export default ExpensesByDate;
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Modal, Button, Form, Table, Pagination, Row, Col, Container, Spinner } from "react-bootstrap";
import { HiOutlineChevronLeft, HiChevronRight } from "react-icons/hi2";

const API_URL = process.env.REACT_APP_API_URL;

function ExpensesByDate() {
  const { date } = useParams();
  const navigate = useNavigate();
  const [expenses, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const limit = 10;

  const formatText = (text) => {
    if (!text || typeof text !== "string") return "NA";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "NA";
    const d = new Date(dateStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const getAuthToken = () => localStorage.getItem("token");

  // ═══════════════════════════════════════════
  // 🔹 FETCH EXPENSES BY DATE
  // ═══════════════════════════════════════════
  const fetchExpenses = async (page = 1) => {
    const token = getAuthToken();
    if (!token) {
      setLoading(false);
      setDataLoading(false);
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        `${API_URL}/expence-datewaise-list?date=${date}&page=${page}&limit=${limit}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch expenses.");
      }
      const data = await response.json();
      if (data.status) {
        setExpenses(data.data || []);
        setTotalPages(data.totalPages || 1);
        setCurrentPage(data.currentPage || page);
        setTotalItems(data.total || data.data?.length || 0);
      } else {
        console.error(data.message);
      }
    } catch (error) {
      console.error("Failed to fetch expenses:", error);
    } finally {
      setLoading(false);
      setDataLoading(false);
    }
  };

  useEffect(() => {
    fetchExpenses(currentPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      fetchExpenses(pageNumber);
    }
  };

  // ─── Format date for display in header ───
  const getFormattedHeaderDate = () => {
    if (!date) return "";
    const parts = date.split("-");
    if (parts.length === 3) {
      const [year, month, day] = parts;
      return `${day}-${month}-${year}`;
    }
    return date;
  };

  // ─── Pagination numbers ───
  const getPageNumbers = () => {
    const pages = [];
    const showEllipsis = totalPages > 7;
    pages.push(1);
    if (showEllipsis && currentPage > 4) pages.push("left-ellipsis");
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) pages.push(i);
    if (showEllipsis && currentPage < totalPages - 3)
      pages.push("right-ellipsis");
    if (totalPages > 1) pages.push(totalPages);
    return pages;
  };

  // ═══════════════════════════════════════════
  // 🎨 RENDER
  // ═══════════════════════════════════════════
  return (
    <>
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #f0f6ff 0%, #e6f0fa 100%)",
          padding: "24px",
          fontFamily: "'Poppins', 'DM Sans', sans-serif",
        }}
      >
        <div style={{ maxWidth: "1500px", margin: "0 auto" }}>
          {/* ═══════ HEADER CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              padding: "24px 30px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              marginBottom: "20px",
              flexWrap: "wrap",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                height: "5px",
                background:
                  "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div
              style={{
                width: "56px",
                height: "56px",
                borderRadius: "16px",
                background: "linear-gradient(135deg, #1e5799, #2b6cb0)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#ffffff",
                fontSize: "26px",
                boxShadow: "0 8px 20px rgba(30, 87, 153, 0.3)",
                flexShrink: 0,
              }}
            >
              📊
            </div>
            <div style={{ flex: 1, minWidth: "200px" }}>
              <h1
                style={{
                  margin: 0,
                  fontSize: "22px",
                  fontWeight: "800",
                  color: "#1e3a5f",
                  letterSpacing: "-0.5px",
                }}
              >
                Datewise CR / DR Ledger Report
              </h1>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  marginTop: "6px",
                  flexWrap: "wrap",
                }}
              >
                <span
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    padding: "4px 12px",
                    borderRadius: "20px",
                    background:
                      "linear-gradient(135deg, #e8f1fb, #dbeafe)",
                    color: "#1e5799",
                    fontSize: "12px",
                    fontWeight: "700",
                    border: "1.5px solid #bfdbfe",
                  }}
                >
                  📅 {getFormattedHeaderDate()}
                </span>
                <span
                  style={{
                    fontSize: "12.5px",
                    color: "#64748b",
                    fontWeight: "500",
                  }}
                >
                  {totalItems} total records
                </span>
              </div>
            </div>

            <button
              type="button"
              onClick={() => navigate("/expenses-date-wise")}
              style={{
                padding: "10px 20px",
                borderRadius: "10px",
                border: "1.5px solid #e2e8f0",
                background: "#ffffff",
                color: "#1e5799",
                fontSize: "13px",
                fontWeight: "700",
                cursor: "pointer",
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 8px rgba(30, 87, 153, 0.06)",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#f0f6ff";
                e.currentTarget.style.borderColor = "#1e5799";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#ffffff";
                e.currentTarget.style.borderColor = "#e2e8f0";
              }}
            >
              ← Back
            </button>
          </div>

          {/* ═══════ MAIN CARD ═══════ */}
          <div
            style={{
              background: "#ffffff",
              borderRadius: "20px",
              boxShadow: "0 12px 40px rgba(30, 87, 153, 0.1)",
              border: "1.5px solid #e2e8f0",
              overflow: "hidden",
            }}
          >
            <div
              style={{
                height: "5px",
                background: "linear-gradient(90deg, #1e5799, #2b6cb0, #1e5799)",
              }}
            />

            <div style={{ padding: "24px 30px" }}>
              {dataLoading ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "70px 20px",
                    color: "#64748b",
                  }}
                >
                  <div
                    style={{
                      width: "44px",
                      height: "44px",
                      border: "3px solid #cbd5e1",
                      borderTop: "3px solid #2b6cb0",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 0.8s linear infinite",
                    }}
                  />
                  <p
                    style={{
                      marginTop: "18px",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                  >
                    Loading expenses...
                  </p>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      overflowX: "auto",
                      overflowY: "visible",
                      borderRadius: "14px",
                      border: "1.5px solid #e2e8f0",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        minWidth: "1500px",
                        borderCollapse: "collapse",
                        fontSize: "12.5px",
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            background:
                              "linear-gradient(135deg, #1e5799, #2b6cb0)",
                          }}
                        >
                          {[
                            "S.N",
                            "Category",
                            "Cat. Type",
                            "Payee",
                            "Payment Mode",
                            "Expense Date",
                            "Pay Date",
                            "Project",
                            "Unit",
                            "Description",
                            "CR Amount",
                            "DR Amount",
                            "Balance",
                          ].map((th, i) => (
                            <th
                              key={i}
                              style={{
                                padding: "14px 12px",
                                color: "#ffffff",
                                fontWeight: "700",
                                fontSize: "11px",
                                textAlign: "left",
                                letterSpacing: "0.5px",
                                textTransform: "uppercase",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {th}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {expenses.length > 0 ? (
                          expenses.map((expense, index) => (
                            <tr
                              key={expense.id}
                              style={{ borderBottom: "1px solid #f1f5f9" }}
                              onMouseEnter={(e) =>
                                (e.currentTarget.style.background =
                                  "#f8fafc")
                              }
                              onMouseLeave={(e) =>
                                (e.currentTarget.style.background =
                                  "transparent")
                              }
                            >
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "700",
                                  color: "#1e5799",
                                }}
                              >
                                {(currentPage - 1) * limit + (index + 1)}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  fontWeight: "600",
                                  color: "#1e3a5f",
                                }}
                              >
                                {expense.category_name}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "10.5px",
                                    fontWeight: "700",
                                    background:
                                      expense.category_type === "cr"
                                        ? "#e7f9eb"
                                        : expense.category_type === "dr"
                                          ? "#feeaeb"
                                          : "#f1f5f9",
                                    color:
                                      expense.category_type === "cr"
                                        ? "#059669"
                                        : expense.category_type === "dr"
                                          ? "#dc2626"
                                          : "#64748b",
                                    textTransform: "uppercase",
                                  }}
                                >
                                  {expense.category_type || "NA"}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#334155",
                                  fontWeight: "500",
                                }}
                              >
                                {formatText(expense.payee)}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    display: "inline-block",
                                    padding: "4px 10px",
                                    borderRadius: "20px",
                                    fontSize: "10.5px",
                                    fontWeight: "700",
                                    background:
                                      expense.type === "online"
                                        ? "#e8f1fb"
                                        : "#fef3c7",
                                    color:
                                      expense.type === "online"
                                        ? "#1e5799"
                                        : "#d97706",
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {expense.type}
                                </span>
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatDate(expense.date)}
                              </td>
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {formatDate(expense.created_at)}
                              </td>
                              <td style={{ padding: "12px", color: "#334155" }}>
                                {expense.project_name || "NA"}
                              </td>
                              <td style={{ padding: "12px", color: "#334155" }}>
                                {expense.plot_shop_villa_no || "NA"}
                              </td>

                              {/* ✅ DESCRIPTION — FULL TEXT, NO TRUNCATION */}
                              <td
                                style={{
                                  padding: "12px",
                                  color: "#64748b",
                                  minWidth: "260px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  lineHeight: "1.5",
                                }}
                              >
                                {expense.description
                                  ? expense.description
                                      .charAt(0)
                                      .toUpperCase() +
                                    expense.description
                                      .slice(1)
                                      .toLowerCase()
                                  : "NA"}
                              </td>

                              <td style={{ padding: "12px" }}>
                                {expense.category_type === "cr" ? (
                                  <span
                                    style={{
                                      color: "#059669",
                                      fontWeight: "800",
                                    }}
                                  >
                                    ₹ {expense.amount}
                                  </span>
                                ) : (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                {expense.category_type === "dr" ? (
                                  <span
                                    style={{
                                      color: "#dc2626",
                                      fontWeight: "800",
                                    }}
                                  >
                                    ₹ {expense.amount}
                                  </span>
                                ) : (
                                  <span style={{ color: "#cbd5e1" }}>—</span>
                                )}
                              </td>
                              <td style={{ padding: "12px" }}>
                                <span
                                  style={{
                                    color:
                                      expense.running_balance >= 0
                                        ? "#059669"
                                        : "#dc2626",
                                    fontWeight: "800",
                                  }}
                                >
                                  ₹{" "}
                                  {expense.running_balance?.toLocaleString() ||
                                    0}
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan="13"
                              style={{
                                textAlign: "center",
                                padding: "60px 20px",
                                color: "#94a3b8",
                                fontWeight: "600",
                                fontSize: "14px",
                              }}
                            >
                              📭 No expenses found for this date.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* ═══════ PAGINATION ═══════ */}
                  {totalPages > 1 && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginTop: "24px",
                        gap: "6px",
                        flexWrap: "wrap",
                      }}
                    >
                      <button
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === 1 ? "#cbd5e1" : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === 1 ? "not-allowed" : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        ‹ Prev
                      </button>

                      {getPageNumbers().map((p, i) => {
                        if (
                          p === "left-ellipsis" ||
                          p === "right-ellipsis"
                        ) {
                          return (
                            <span
                              key={`ellipsis-${i}`}
                              style={{
                                padding: "0 6px",
                                color: "#94a3b8",
                                fontWeight: "700",
                              }}
                            >
                              ...
                            </span>
                          );
                        }
                        const isActive = p === currentPage;
                        return (
                          <button
                            key={p}
                            onClick={() => handlePageChange(p)}
                            style={{
                              minWidth: "38px",
                              height: "38px",
                              borderRadius: "10px",
                              border: isActive
                                ? "none"
                                : "1.5px solid #e2e8f0",
                              background: isActive
                                ? "linear-gradient(135deg, #1e5799, #2b6cb0)"
                                : "#ffffff",
                              color: isActive ? "#ffffff" : "#334155",
                              fontWeight: "700",
                              fontSize: "13px",
                              cursor: "pointer",
                              boxShadow: isActive
                                ? "0 6px 16px rgba(30, 87, 153, 0.3)"
                                : "none",
                              transition: "all 0.18s ease",
                            }}
                          >
                            {p}
                          </button>
                        );
                      })}

                      <button
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        style={{
                          padding: "8px 14px",
                          borderRadius: "10px",
                          border: "1.5px solid #e2e8f0",
                          background: "#ffffff",
                          color:
                            currentPage === totalPages
                              ? "#cbd5e1"
                              : "#1e5799",
                          fontWeight: "700",
                          fontSize: "13px",
                          cursor:
                            currentPage === totalPages
                              ? "not-allowed"
                              : "pointer",
                          display: "inline-flex",
                          alignItems: "center",
                          gap: "6px",
                        }}
                      >
                        Next ›
                      </button>
                    </div>
                  )}

                  {expenses.length > 0 && (
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: "12px",
                        color: "#94a3b8",
                        marginTop: "12px",
                        marginBottom: 0,
                        fontWeight: "500",
                      }}
                    >
                      Page {currentPage} of {totalPages} • {totalItems} total
                      records
                    </p>
                  )}
                </>
              )}
            </div>
          </div>

          {/* Footer Copyright */}
          <p
            style={{
              textAlign: "center",
              color: "#94a3b8",
              fontSize: "12.5px",
              marginTop: "24px",
              fontWeight: "500",
            }}
          >
            © {new Date().getFullYear()} A2 Demo Real Estates Pvt Ltd. All
            Rights Reserved.
          </p>
        </div>
      </div>

      <style>{`
        @keyframes spin {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
      `}</style>
    </>
  );
}

export default ExpensesByDate;